import { apiConstants } from "../../config";
import { apiGet, apiDelete } from "../../../../shared/services";

const fetchCustomers = async options => {
  const url = apiConstants.customer;
  return await apiGet(url, {
    params: { page: 1, itemsPerPage: "-1", ...options }
  });
};

const fetchCountries = async options => {
  const url = apiConstants.country;
  return await apiGet(url, { params: options });
};

const fetchHandbooks = async id => {
  const url = apiConstants.handbooks;
  return await apiGet(url + "/" + id);
};

const fetchItems = async options => {
  const url = apiConstants.item;
  return await apiGet(url, { params: options });
};

const fetchWallconnections = async options => {
  const url = apiConstants.wallconnection;
  return await apiGet(url, { params: options });
};

const fetchFrames = async options => {
  const url = apiConstants.frame;
  return await apiGet(url, { params: options });
};

const fetchItemItems = async options => {
  const url = apiConstants.item;
  return await apiGet(url, { params: options });
};

const fetchEdgespacers = async options => {
  const url = apiConstants.edgespacer;
  return await apiGet(url, { params: options });
};

const fetchFavorites = async options => {
  const url = apiConstants.favorites;
  return await apiGet(url, { params: options });
};

const deleteFavorite = async id => {
  const url = apiConstants.favorites;
  return await apiDelete(url + "/" + id);
};

const fetchFavorite = async id => {
  const url = apiConstants.favorites;
  return await apiGet(url + "/" + id);
};

export {
  fetchCustomers,
  fetchCountries,
  fetchItems,
  fetchWallconnections,
  fetchFrames,
  fetchItemItems,
  fetchEdgespacers,
  fetchFavorites,
  deleteFavorite,
  fetchFavorite,
  fetchHandbooks
};
